<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">科目余额表</span>
		</div>
		<div class="margin-right-left margin-top">
			<!-- <account-date-choose v-model="accountDate"/> -->
			时间：<a-range-picker :locale="locale" v-model="dp"  @change="onTimeChange" />
			<div class="float-right">
				<!-- <Checkbox v-model="showNumPrice">显示数量金额</Checkbox> -->
			</div>
		</div>
		<div class="h-panel-body">
			<table class="balance" v-if="!showNumPrice">
				<thead class="header">
				<tr>
					<td rowspan="2"  style="width:330px;">科目编码</td>
					<td rowspan="2"  style="width:330px;">科目名称</td>
					<td colspan="2" style="width:330px;">期初余额</td>
					<td colspan="2" style="width:330px;">本期发生额</td>
					<td colspan="2" style="width:330px;">期末余额</td>
				</tr>
				<tr>
					<td style="width:165px;">借方</td>
					<td style="width:165px;">贷方</td>
					<td style="width:165px;">借方</td>
					<td style="width:165px;">贷方</td>
					<td style="width:165px;">借方</td>
					<td style="width:165px;">贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjecId">
					<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
					<td :style="{'padding-left':(item.level)*10+'px;'+(item.level==0?'font-weight:bold':'')}"><span class="text-hover">{{item.name}}</span></td>
					<td align="right">{{item.beginningDebitBalance|numFormat}}</td>
					<td align="right">{{item.beginningCreditBalance|numFormat}}</td>
					<td align="right">
						<span v-if="item.level!=0" style="color:#3788ee;cursor: pointer;" @click="showDetailed(item.code,item.subjectId)">
							{{item.currentDebitAmount|numFormat}}
						</span>
						<span v-if="item.level==0"  >
							{{item.currentDebitAmount|numFormat}}
						</span>
					</td>
					<td align="right">
						<span v-if="item.level!=0" style="color:#3788ee;cursor: pointer;" @click="showDetailed(item.code,item.subjectId)">
						{{item.currentCreditAmount|numFormat}}
						</span>
						<span v-if="item.level==0"  >
							{{item.currentCreditAmount|numFormat}}
						</span>
					</td>
					<td :class="{tip:item.endingDebitBalance<0}" align="right">{{item.endingDebitBalance|numFormat}}</td>
					<td :class="{tip:item.endingCreditBalance<0}" align="right">{{item.endingCreditBalance|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
			<table class="balance" v-else>
				<thead class="header">
				<tr>
					<td rowspan="2">科目编码</td>
					<td rowspan="2">科目名称</td>
					<td colspan="4">期初余额</td>
					<td colspan="4">本期发生额</td>
					<td colspan="4">期末余额</td>
				</tr>
				<tr>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjecId">
					<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
					<td :style="{'padding-left':(item.level)*10+'px;'+(item.level==0?"font-weight:bold":"")}"><span class="text-hover">
						 {{item.name}}
					</span></td>
					<td class="text-right">&nbsp;</td>
					<td class="text-right" align="right">{{item.beginningDebitBalance|numFormat}}</td>
					<td class="text-right">&nbsp;</td>
					<td class="text-right" align="right">{{item.beginningCreditAmount|numFormat}}</td>

					<td class="text-right" align="right">{{item.currentDebitAmountNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentCreditAmountNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentCreditAmount|numFormat}}</td>

					<td class="text-right" align="right">{{item.endingDebitBalanceNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingDebitBalance|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingCreditBalanceNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingCreditBalance|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="14" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>

		<!-- 明细账 -->
		<Modal title="明细账" v-model="detailedVisible"  :closeOnMask="false" >
			<div slot="header">明细账</div>
			<div style="width:950px;height:500px;overflow: auto;">
			<table class="cus-table"  >
					<thead class="header">
					<tr>
						<td>日期</td>
						<td>凭证字号</td>
						<td>科目</td>
						<td>摘要</td>
						<td>借方</td>
						<td>贷方</td>
						<td>方向</td>
						<td>余额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in d_dataList" :key="item.subjecId">
						<td>{{item.voucherDate}}</td>
						<td> 
							<span style="color:#3788ee;cursor: pointer;" @click="showVoucher(item.voucherId)" v-if="item.code!=undefined && item.code!=''">
								{{item.word}}-{{item.code}}
							</span>
						</td>
						<td>
							{{item.subjectName}}
						</td>
						<td>{{item.summary}}</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td class="text-center">{{item.balanceDirection}}</td>
						<td class="text-right">{{item.balance|numFormat}}</td>
					</tr>
					<tr v-if="!d_dataList.length">
						<td colspan="8" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
				</div>
				<div slot="footer">
					<Button @click="detailedVisible=false">关闭</Button> 
				</div>
		</Modal>
		<Modal title="凭证详情" v-model="VoucherVisible"  :closeOnMask="false" >
			<div slot="header">凭证详情</div>
			<voucher-table ref="voucherTable" v-model="voucherTable"/>
			<div slot="footer">
				<router-link v-if="this.voucherId" :to="{name:'VoucherForm',params:{voucherId:this.voucherId}}" target="_blank">
				<Button @click="VoucherVisible=false" >编辑</Button> 	
				</router-link>
				&nbsp;
				<Button @click="VoucherVisible=false">关闭</Button> 
			</div>
		</Modal>
	</app-content>
</template>

<script>
import VoucherTable from "../../components/VoucherTable";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import {mapState} from 'vuex';
import 'moment/locale/zh-cn';
	export default {
		name: "SubjectBalance",
		components: {VoucherTable},
		data() {
			return {
				dataList: [],
				accountDate: null,
				showNumPrice: false,
				loading: false,
				locale,
				startTime:undefined,
				endTime:undefined,
				dp:[],
				//明细账
				detailedVisible:false,
				d_dataList:[],
				//凭证
				VoucherVisible:false,
				voucherTable: {voucherItems: []},
				voucherId:undefined,

			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			voucherItems() {
				return this.voucherTable.voucherItems;
			},
		},
		watch: {
			accountDate() {
				this.loadList();
			},
			showNumPrice() {
				this.loadList();
			}
		},
		created(){
			this.loadList();
		},
		methods: {
			loadList() {
				if(this.startTime==undefined ||this.startTime=='' || this.endTime==undefined || this.endTime==''){
					this.startTime = moment().startOf("month").format("YYYY-MM-DD");
					this.endTime = moment().endOf("month").format("YYYY-MM-DD");
					this.dp = [
						this.startTime,
						this.endTime
					];
				}
				this.loading = true;
				this.$api.accountbook.loadSubjectBalance2({
					startTime: this.startTime,
					endTime:this.endTime,
					showNumPrice: this.showNumPrice
				}).then(({data}) => {
					//增加科目类型合计行 资产、负债、权益、成本、损益  
					var zc=this.initSummaryObj('资产');
					var fz=this.initSummaryObj('负债');
					var qy=this.initSummaryObj('权益');
					var cb=this.initSummaryObj('成本');
					var sy=this.initSummaryObj('损益'); 
					var hj;
					data.forEach(item=>{
						if(item.name!='合计'){
							if(item.level==1){
								if(item.subjectType=='资产' ){
									zc = this.calcSummaryObj(zc,item); 
								}else if (item.subjectType=='负债'){
									fz = this.calcSummaryObj(fz,item);
								}
								else if (item.subjectType=='权益'){
									qy = this.calcSummaryObj(qy,item);
								}
								else if (item.subjectType=='成本'){
									cb = this.calcSummaryObj(cb,item);
								}
								else if (item.subjectType=='损益'){
									sy = this.calcSummaryObj(sy,item);
								}
							}
						}else{
							hj=item;
						}
					})
					data.pop();
					data.push(zc);
					data.push(fz);
					data.push(qy);
					data.push(cb);
					data.push(sy);
					data.push(hj);
					console.log(data);
					this.dataList = data;
					this.loading = false;
				});
			},
				//时间筛选
			onTimeChange(date, dateString){
				this.startTime = dateString[0];
				this.endTime = dateString[1];
				this.loadList();
			},
			//明细账
			showDetailed(subjectCode,subjectId){
				this.detailedVisible=true;
				this.loading = true;
				this.$api.accountbook.loadVoucherDetails2({
					startTime: this.startTime,
					endTime:this.endTime,
					subjectId: subjectId,
					showNumPrice: false,
					subjectCode: subjectCode
				}).then(({data}) => {
					this.d_dataList = data;
					this.loading = false;
				});
			},
			showVoucher(voucherId){
				console.log(voucherId);
				this.voucherId =voucherId;
				this.VoucherVisible=true;
				this.$api.voucher.load(voucherId).then(({data}) => {
					this.$refs.voucherTable.initValue(data.details);
				});
			},
			initSummaryObj(name){
				return { 
					"beginningBalance": 0,
					"beginningCreditBalance": 0,
					"beginningDebitBalance": 0, 
					"currentCreditAmount": 0,
					"currentCreditAmountNum": 0,
					"currentDebitAmount": 0,
					"currentDebitAmountNum": 0,
					"endingBalance": 0,
					"endingCreditBalance": 0,
					"endingCreditBalanceNum": 0,
					"endingDebitBalance": 0,
					"endingDebitBalanceNum": 0,
					"level": 0,
					"name": name+'合计',
					"parentId": 0,   
				}
			},
			calcSummaryObj(summaryItem,obj){
				var o = { 
					"beginningBalance": 0,
					"beginningCreditBalance": 0,
					"beginningDebitBalance": 0, 
					"currentCreditAmount": 0,
					"currentCreditAmountNum": 0,
					"currentDebitAmount": 0,
					"currentDebitAmountNum": 0,
					"endingBalance": 0,
					"endingCreditBalance": 0,
					"endingCreditBalanceNum": 0,
					"endingDebitBalance": 0,
					"endingDebitBalanceNum": 0,
					"level": 0,
					"name": summaryItem.name,
					"parentId": 0,   
				}
				o.beginningBalance = summaryItem.beginningBalance + (obj.beginningBalance==undefined?0:obj.beginningBalance);
				o.beginningCreditBalance = summaryItem.beginningCreditBalance + (obj.beginningCreditBalance==undefined?0:obj.beginningCreditBalance);
				o.beginningDebitBalance = summaryItem.beginningDebitBalance + (obj.beginningDebitBalance==undefined?0:obj.beginningDebitBalance)
				o.currentCreditAmount = summaryItem.currentCreditAmount + (obj.currentCreditAmount==undefined?0:obj.currentCreditAmount);
				o.currentCreditAmountNum = summaryItem.currentCreditAmountNum + (obj.currentCreditAmountNum==undefined?0:obj.currentCreditAmountNum);
				o.currentDebitAmount = summaryItem.currentDebitAmount + (obj.currentDebitAmount==undefined?0:obj.currentDebitAmount);
				o.currentDebitAmountNum = summaryItem.currentDebitAmountNum + (obj.currentDebitAmountNum==undefined?0:obj.currentDebitAmountNum);
				o.endingBalance = summaryItem.endingBalance + (obj.endingBalance==undefined?0:obj.endingBalance);
				o.endingCreditBalance = summaryItem.endingCreditBalance + (obj.endingCreditBalance==undefined?0:obj.endingCreditBalance);
				o.endingCreditBalanceNum = summaryItem.endingCreditBalanceNum + (obj.endingCreditBalanceNum==undefined?0:obj.endingCreditBalanceNum);
				o.endingDebitBalance = summaryItem.endingDebitBalance + (obj.endingDebitBalance==undefined?0:obj.endingDebitBalance);
				o.endingDebitBalanceNum = summaryItem.endingDebitBalanceNum + (obj.endingDebitBalanceNum==undefined?0:obj.endingDebitBalanceNum); 
				return o;
			}
		}
	}
</script>

<style scoped lang="less">
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
